import sortBy from "lodash/sortBy";
import { useMemo } from "react";
import type { MediaImage } from "./mediaApi";
import { useImages } from "./useImages";

export const useFilteredAndOrderedImages = (query: string, selectedTags: string[] = []) => {
  const { images, ...others } = useImages();

  const sortedImages = useMemo(
    () => filterAndSortImages(images, query, undefined, selectedTags),
    [images, query, selectedTags],
  );
  return { images: sortedImages, ...others };
};

export function filterAndSortImages(
  images: MediaImage[],
  query: string,
  selectedImages?: Omit<MediaImage, "tags" | "isPrivate">[],
  selectedTags: string[] = [],
) {
  const selectedIds = new Set(selectedImages?.map((i) => i.id) ?? []);
  const filteredImages = images.filter(
    (i) =>
      (!query || i.tags.some((tag) => tag.toLowerCase().includes(query.toLowerCase()))) &&
      (selectedTags.length === 0 || selectedTags.every((selectedTag) => i.tags.includes(selectedTag))),
  );
  return sortBy(filteredImages, (i) => {
    const tags = i.tags.map((t) => t.toLowerCase()).join("#");
    const selected = selectedIds.has(i.id) ? "0" : "1";
    return `${selected}:${tags}`;
  });
}
